import { useFeatureSwitchEnabled } from '@hooks/useFeatureSwitchEnabled';
import { IDySpaEvent } from '@hooks/useGTM';
import { FEATURES_LIST } from '../context/featureSwitchApp';

export const useDynamicYieldAPI = () => {
    const isDynamicYieldEnabled = useFeatureSwitchEnabled(FEATURES_LIST.FEATURE_SWITCH_DYNAMIC_YIELD_ENABLED);
    const isDynamicYieldDebugEnabled = useFeatureSwitchEnabled(
        FEATURES_LIST.FEATURE_SWITCH_DYNAMIC_YIELD_DEBUGGING_ENABLED
    );

    const fireDynamicYieldSPAEvent = (value: any, DynamicYield: IDySpaEvent) => {
        if (!isDynamicYieldEnabled) return null;

        const gtmToDyContext = (gtmObject: any) => {
            let pageType = undefined;
            let contextData = '';

            switch (gtmObject.mainStepName) {
                case 'home page': {
                    pageType = 'HOMEPAGE';
                    break;
                }
                case 'finition': {
                    pageType = 'CATEGORY';
                    contextData = gtmObject.vehicleModelBodystyle?.split('|')?.[0];
                    break;
                }
                case 'personnalization': {
                    pageType = 'PRODUCT';
                    contextData = gtmObject.vehicleModelBodystyle?.split('|')?.[0];
                    break;
                }
                case 'summary': {
                    pageType = 'CART';
                    contextData = gtmObject.vehicleModelBodystyle
                        ? gtmObject.vehicleModelBodystyle?.split('|')?.[0]
                        : undefined;
                    break;
                }
                default:
                    pageType = 'OTHER';
                    break;
            }

            return {
                type: pageType,
                data: [contextData],
            };
        };

        if (isDynamicYieldDebugEnabled) {
            console.log('dataLayerPushed, value', value);
            console.log('window.CSR', typeof window !== 'undefined' ? (window as any).CSR : '');
        }

        if (!DynamicYield?.fireSPAEvent) return true;

        const context = gtmToDyContext(value);
        const countAsPageview = !!DynamicYield?.countAsPageview;

        if ((window as any)?.DY && (window as any)?.DY?.API && typeof (window as any)?.DY?.API === 'function') {
            (window as any).DY.API('spa', {
                context,
                countAsPageview,
            });
            if (isDynamicYieldDebugEnabled) {
                console.group(' %c DY API ', 'background: orange; padding: 6px 9px;');
                console.log('window.DY.API called, context', context, 'countAsPageview', countAsPageview);
                console.groupEnd();
            }
        }
    };

    return { fireDynamicYieldSPAEvent };
};
